module.exports = __webpack_public_path__ + "static/hy-538cde4b25cd5c73eee0b8a5b821dd20.png";